export default [
  {
    path: '/report/statement',
    name: 'Monthly statement',
    component: () => import('@/views/report/list/index.vue'),
    meta: {
      icon: 'icon-baobiaoguanli1',
      resourceCode: 'report:statement',
    },
  },
  {
    path: '/report/success-rate',
    name: 'Success Rate Report',
    component: () => import('@/views/report/success-rate/index.vue'),
    meta: {
      icon: 'icon-baobiaoguanli1',
      resourceCode: 'report:successRate',
    },
  },
  {
    path: '/report/refuse-rate',
    name: 'Refuse Rate Report',
    component: () => import('@/views/report/refuse-rate/index.vue'),
    meta: {
      icon: 'icon-baobiaoguanli1',
      resourceCode: 'report:refuseRate',
    },
  },
  {
    path: '/report/refuse-rate/view',
    name: 'Refuse Rate Report Details',
    component: () => import('@/views/report/refuse-rate/view/index.vue'),
    meta: {
      activeMenu: '/report/refuse-rate',
      resourceCode: 'report:refuseRate:view',
      name: 'message.report.transactionReportDetails',
    },
  },
];
